import DashboardPage from './components/DashboardPage';

const routes = [
  {
    path: '/',
    name: 'menu.dashboard',
    className: 'menu-dashboard',
    icon: 'dashboard',
    customIcon: true,
    loginRequired: true,
    component: DashboardPage,
    weight: 1,
    permission: ['dashboard'],
    children: [],
  },
];

export default routes;
